import React, { memo } from 'react';

type LoadingProps = {
    heightLoading: string
}

const Loading = ({heightLoading}: LoadingProps) => {
    return (
        <article className={`${heightLoading} d-flex justify-content-center align-items-center loading-container`}>
            <div className="spinner-border custom-spinner" role="status">
            </div>
        </article>
    )
}

export default memo(Loading);